import React from 'react';

export function AppStoreBadges() {
  return (
    <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mt-8">
      <div className="relative group">
        <img 
          src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg" 
          alt="Get it on Google Play" 
          className="h-16 opacity-40"
        />
        <div className="absolute inset-0 flex items-center justify-center">
          <span className="bg-black/70 px-3 py-1 rounded-full text-white text-sm font-medium">
            Coming Soon
          </span>
        </div>
      </div>
      
      <div className="relative group">
        <img 
          src="https://upload.wikimedia.org/wikipedia/commons/3/3c/Download_on_the_App_Store_Badge.svg" 
          alt="Download on the App Store" 
          className="h-16 opacity-40"
        />
        <div className="absolute inset-0 flex items-center justify-center">
          <span className="bg-black/70 px-3 py-1 rounded-full text-white text-sm font-medium">
            Coming Soon
          </span>
        </div>
      </div>
    </div>
  );
}